<p-panel [toggleable]="true">
  <ng-template pTemplate="header">
    <div class="filter-card-header">
      <span class="filter-icon"><i class="fa fa-download"></i></span>
      <span class="filter-card-title">Export DAD Exchange report (CSV)</span>
    </div>
  </ng-template>
  <div class="filter-fields">
    <div class="filter-field">
      <p-floatLabel>
        <p-dropdown [(ngModel)]="csvSelectedOption.date" [options]="usageMonth" appendTo="body" inputId="csvUsageMonth"
                    panelStyleClass="portal-overlay"></p-dropdown>
        <label for="csvUsageMonth">Usage Month</label>
      </p-floatLabel>
    </div>
    <div class="filter-field">
      <p-floatLabel>
        <p-dropdown (onChange)="changeCsvOptions()" [(ngModel)]="csvSelectedOption.exchange" [options]="exchangeNamesList"
                    appendTo="body" inputId="csvExchange" panelStyleClass="portal-overlay"></p-dropdown>
        <label for="csvExchange">Exchange</label>
      </p-floatLabel>
    </div>
    <div class="filter-field">
      <p-floatLabel>
        <p-dropdown [(ngModel)]="csvSelectedOption.mode" [options]="csvOptions" appendTo="body" inputId="csvMode"
                    panelStyleClass="portal-overlay"></p-dropdown>
        <label for="csvMode">Mode</label>
      </p-floatLabel>
    </div>
    <div class="filter-actions">
      <button (click)="exportCSV()" class="primary-btn" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>
        Export
      </button>
    </div>
  </div>
</p-panel>
